import { useEffect, useState } from "react";
import { isEmptyObject } from "../utils";

type DataFetchStateType = {
  data?: any;
  loading?: boolean;
  error?: any;
};

export type DataFetchOptionsType = {
  requestId?: string;
  serviceName?: string;
  req?: any;
  res?: any;
  loading?: boolean;
  error?: any;
};

function useDataFetch(method: any, options?: DataFetchOptionsType) {
  const [fetchState, setFetchState] = useState<DataFetchStateType>(() => {
    return { loading: true };
  });
  const { data, error, loading } = fetchState;

  useEffect(() => {
    if (options?.loading == true) {
      setFetchState({ loading: true });
    } else if (options?.res || options?.error) {
      setFetchState({
        loading: false,
        data: options?.res,
        error: options?.error,
      });
    } else if (!isEmptyObject(method)) {
      const fetchData = async () => {
        setFetchState({ loading: true });
        await method(options?.req)
          .then((data) => {
            setFetchState({ loading: false, data });
          })
          .catch((err) => {
            setFetchState({ loading: false, data: [], error: err });
          });
      };
      fetchData();
    }
  }, [
    options?.requestId,
    options?.serviceName,
    options?.res,
    options?.error,
    options?.loading,
  ]);

  return { data, error, loading };
}

export default useDataFetch;
